import React from "react";
import { Accordion } from "Components/Base/Surfaces/Accordion";
import Item from "./Item";
import { useMyLearning } from "../context";

const AccordionCourses = ({
  isManagerOrAdmin,
  openDetails,
  closeDetails,
  languageContext,
}) => {
  const { filteredCourses, personalId, listView, viewLimit, viewLimitNr } =
    useMyLearning();

  const getFilteredActiveCourses = () => {
    if (!viewLimit || !filteredCourses.active) {
      return filteredCourses.active;
    }

    return filteredCourses.active.slice(
      0,
      Math.min(viewLimitNr, filteredCourses.active.length),
    );
  };

  return (
    <Accordion
      defaultExpanded
      slotProps={{
        transition: {
          unmountOnExit: true,
          timeout: 0,
        },
      }}
      disableGutters
      TransitionProps={{ timeout: 0 }}
      summaryText={languageContext("courses")}
      summaryVariant="h2"
      detailsText={
        <div
          className={`${listView ? "learning-courselist flex column" : "cardview-courselist flex flex-wrap"}`}
          id="learningActivitiesMyLearningList"
        >
          {Array.isArray(filteredCourses.active) &&
            getFilteredActiveCourses().map((c) => (
              <Item
                key={
                  c.courseType === 2
                    ? `${c.courseId}_${c.activityId}`
                    : c.courseId
                }
                course={c}
                personalId={personalId}
                openDetails={openDetails}
                closeDetails={closeDetails}
                isManagerOrAdmin={isManagerOrAdmin}
              />
            ))}
        </div>
      }
    />
  );
};

export default AccordionCourses;
